// extracted by mini-css-extract-plugin
module.exports = {"heroBg":"Hero_heroBg__yymoK","typewriter":"Hero_typewriter__oNmQL","cursor":"Hero_cursor__joJhn","blink":"Hero_blink__0Kg7y"};